module.exports = __webpack_public_path__ + "img/20200515_161632.369ccda3.jpg";